// This file was auto-generated by Fern from our API Definition.
export const StringOperator = {
    Startswith: "startswith",
    Endswith: "endswith",
    Contains: "contains",
    Matches: "matches",
    Like: "like",
};
